export const PERMISSIONS = {
  MODULES: {
    DASHBOARD: 'DASHBOARD',
    USERS: 'USUARIOS',
    CLIENTS: 'CLIENTES',
    TANDAS: 'TANDAS',
    CUENTAS: 'CUENTAS',
    PAYMENTS: 'PAGOS',
    BANK_ACCOUNTS: 'CUENTAS_BANCARIAS',
    CONFIGURATION: 'CONFIGURACION',
  },
  ACTIONS: {
    VIEW: 'VISUALIZAR',
    CREATE: 'CREAR',
    UPDATE: 'ACTUALIZAR',
    GESTIONAR_LISTA_NEGRA: 'GESTIONAR_LISTA_NEGRA',
    DELETE: 'ELIMINAR',
    ADD_PERMISSION: 'ASIGNAR_PERMISOS',
    RECHAZAR_COMPRA: 'RECHAZAR_COMPRA',
    ACEPTAR_COMPRA: 'ACEPTAR_COMPRA',
    PERMITIR_CUENTAS_MISMA_PERSONA: 'PERMITIR_CUENTAS_MISMA_PERSONA',
    VER_PAGOS_NIVEL1: 'VER_PAGOS_NIVEL1',
    VER_PAGOS_NIVEL2: 'VER_PAGOS_NIVEL2',
    CONFIRMAR_PAGO_CUENTA_PRINCIPAL: 'CONFIRMAR_PAGO_CUENTA_PRINCIPAL',
    ACTUALIZAR_PAGOS_NIVEL2: 'ACTUALIZAR_PAGOS_NIVEL2',
    VER_CUENTAS: 'VER_CUENTAS',
    VER_SOLICITUDES_CUENTAS: 'VER_SOLICITUDES_CUENTAS',
    REMOVER_CUENTAS: 'REMOVER_CUENTAS',
    CUENTAS_REMOVIDAS: 'CUENTAS_REMOVIDAS',
    INGRESAR_CUENTAS_PENDIENTES: 'INGRESAR_CUENTAS_PENDIENTES',
    ADMINISTRACION_TANDAS: 'ADMINISTRACION_TANDAS',
    ACTUALIZAR_TANDAS: 'ACTUALIZAR_TANDAS',
    CREAR_TANDAS: 'CREAR_TANDAS',
    VER_DETALLES_TANDAS: 'VER_DETALLES_TANDAS',
    VER_TERMINOS_CONDICIONES: 'VER_TERMINOS_CONDICIONES',
    CREAR_TERMINOS_CONDICIONES: 'CREAR_TERMINOS_CONDICIONES',
    VER_RED_TANDAS: 'VER_RED_TANDAS',
    VER_CONFIGURACION: 'VER_CONFIGURACION',
  },
};
